import React from 'react'
import{Box, Text, Grid, Image} from '@chakra-ui/react'
import Card from './Card'

const Container =({img,title,text})=>{
  return(
    <Box mb='2rem' gap='6'>
      <Image src={img} alt='image'/>
      <Text textAlign='left'fontWeight='500' fontFamily='Duplicate Sans' mt='.75rem' textTransform='capitalize' fontSize={['18px','1.3rem','1.3rem','32px']} >{title}</Text>
        <Text color='#999999' w='60%' textAlign='left' fontFamily='Work Sans' fontSize={['.75rem','.8rem','.8rem', '1rem']} mt='.75rem' lineHeight='28px' >{text}</Text>
    </Box>
  )
}

const Values = () => {
  return (
    <Box h='100%' w='full' p='3rem' display='flex' justifyContent='center' alignItems='center' flexDirection='column' >
        <Text fontSize={['1.5rem','2rem','2.3rem','3rem']} textAlign={['left','center']} fontFamily='Duplicate Sans' fontWeight='500'>
        The values we live by
        </Text>
        <Text fontFamily='Work Sans' fontSize={['.75rem','.8rem','.8rem','1rem']} lineHeight='28px'  mt='1rem' textAlign={['left','center']} color='#445368'>We created NeemblePay because we want to help the 
        banked community or<Text as='br' display={['none','block']}/>
millenials by making withdrawal of money seamless and easy</Text>
    <Grid mt='5rem' p='1rem' display={['none','grid']} templateColumns={['repeat(1,1fr)', 'repeat(2,1fr)','repeat(2,1fr)','repeat(3,1fr)']} gap={['6','6','6','12']}>
        <Card color='#F3F4FC' title='Teamwork' text='We are a family at Neemble, so we 
leverage on each other’s skills to
create amazing solutions.' />
<Card color='#FCF7E8' title='Transparency' text='We are a family at Neemble, so we 
leverage on each other’s skills to
create amazing solutions.' />
<Card color='#F3F4FC' title='Trust' text='We are a family at Neemble, so we 
leverage on each other’s skills to
create amazing solutions.' />
<Card color='#FCF7E8' title='Quality' text='We are a family at Neemble, so we 
leverage on each other’s skills to
create amazing solutions.' />
<Card color='#F3F4FC' title='Communication' text='We are a family at Neemble, so we 
leverage on each other’s skills to
create amazing solutions.' />
<Card color='#FCF7E8' title='Respect' text='We are a family at Neemble, so we 
leverage on each other’s skills to
create amazing solutions.' />
    </Grid>
    <Grid mt='5rem' p='1rem' display={['grid','none']} templateColumns={['repeat(1,1fr)', 'repeat(2,1fr)','repeat(2,1fr)','repeat(3,1fr)']} gap={['6','6','6','12']}>
      <Container text='Displaying the highest level of Integrity in the way we conduct our business' title='integrity' img='integrityvalue.png'/>
      <Container text='Harnessing the power of Technology to deliver better customer experience' title='team' img='teamvalue.png'/>
      <Container text='Promoting respect and  in the work place and community' title='respect' img='respectvalue.png'/>
      <Container text='Setting the standard for the best Corporate Citizenship in the communities we work' title='trust' img='trustvalue.png'/>
    </Grid>
    </Box>
  )
}

export default Values